declare global {
  interface Window {
    BmbyScheduler?: {
      MeetingsSchedulerInit: new (doc: Document) => void
    }
  }
}

/**
 * Opens BMBY scheduler using their official script.
 * Auto-clicks the generated button so users see the scheduler immediately.
 */
export const scheduleBmbyMeeting = (
  locale: string,
  bmbyMeetingId: string | number = "5BAE7E64-8643-4844-BB7B-C87B6FDC2A9A",
) => {
  const lang = locale === "en" ? "en" : "he"

  // Remove any existing scheduler container
  const existingContainer = document.getElementById("bmby-scheduler-container")
  if (existingContainer) {
    existingContainer.remove()
  }

  // Create hidden container for the scheduler (hidden so user doesn't see the button)
  const container = document.createElement("div")
  container.id = "bmby-scheduler-container"
  container.style.cssText =
    "position: fixed; top: -9999px; left: -9999px; opacity: 0; pointer-events: none;"

  // Create the BMBY scheduler div
  const schedulerDiv = document.createElement("div")
  schedulerDiv.className = "bmby-scheduler"
  schedulerDiv.setAttribute("data-guid", String(bmbyMeetingId))
  schedulerDiv.setAttribute("data-lang", lang)
  container.appendChild(schedulerDiv)
  document.body.appendChild(container)

  // Load styles if not already loaded
  let styles = document.head.querySelector("#bmbySchedulerStyles") as HTMLLinkElement | null
  if (!styles) {
    styles = document.createElement("link")
    styles.rel = "stylesheet"
    styles.id = "bmbySchedulerStyles"
    styles.href = "https://bmbyscheduler.azurewebsites.net/bmby-scheduler.css"
    document.head.appendChild(styles)
  }

  // Function to initialize and auto-click the summon-scheduler button
  const initAndAutoClick = () => {
    if (window.BmbyScheduler) {
      new window.BmbyScheduler.MeetingsSchedulerInit(document)

      // Try to find and click the summon-scheduler button with retries
      const tryClickButton = (attempts = 0) => {
        if (attempts > 20) return // Give up after 2 seconds

        const summonButton = document.querySelector(".summon-scheduler") as HTMLElement
        if (summonButton) {
          // Temporarily make container interactive to allow click
          container.style.pointerEvents = "auto"
          summonButton.click()
          // Hide container again after click
          container.style.pointerEvents = "none"
        } else {
          // If not found, retry after a short delay
          setTimeout(() => tryClickButton(attempts + 1), 100)
        }
      }

      // Start trying to click after a small delay
      setTimeout(() => tryClickButton(), 50)
    }
  }

  // Load script if not already loaded
  let script = document.head.querySelector("#bmbySchedulerScript") as HTMLScriptElement | null
  if (!script) {
    script = document.createElement("script")
    script.src = "https://bmbyscheduler.azurewebsites.net/bmby-scheduler.js"
    script.id = "bmbySchedulerScript"
    script.defer = true
    script.onload = initAndAutoClick
    document.head.appendChild(script)
  } else {
    // Script already loaded, just reinitialize
    initAndAutoClick()
  }
}
